import * as React from 'react';
import { view } from '@risingstack/react-easy-state';
import { ToastList } from 'ui';
import { toastStore, dismissToast } from 'stores/toast';

export const ToastStore = view(() => (
  <ToastList messages={toastStore.toasts} dismissToast={dismissToast} />
));
